import type { ObjectShorthandValue } from '@archipro-design/aria';
import {
    useStyles,
    type ButtonProps,
    Grid,
    Button,
    pxToRem,
} from '@archipro-design/aria';
import type { ReactNode } from 'react';
import * as S from './FeaturedItems.mobile.style';
import FeaturedTitleMobile from '../featured-title/FeaturedTitle.mobile';

interface FeaturedItemsMobileProps {
    title: string | ReactNode;
    gridType: 'single' | 'double';
    displayButton: boolean;
    button: ObjectShorthandValue<ButtonProps>;
    children?: ReactNode;
}

const FeaturedItemsMobile = ({
    children,
    title,
    gridType = 'single',
    button,
    displayButton = true,
}: FeaturedItemsMobileProps) => {
    const { css } = useStyles({ twoColumns: gridType === 'double' });
    return (
        <div className={css(S.FeaturedItemsdWrapper)}>
            <FeaturedTitleMobile>{title}</FeaturedTitleMobile>
            <Grid
                className={css(S.TileGrid)}
                columns={gridType === 'double' ? '1fr 1fr' : '1fr'}
            >
                {children}
            </Grid>
            {displayButton && (
                <div className={css(S.ButtonRow)}>
                    <Button
                        className={css(S.LoadMore)}
                        fluid
                        size={16}
                        color="dark"
                        transparent
                        outlined
                        preventScrollReset={true}
                        variables={{
                            buttonPadding: pxToRem(15),
                        }}
                        {...button}
                    >
                        {button?.children || null}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default FeaturedItemsMobile;
